import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class SeatInput extends Component {
    static propTypes = {
        updateSeats: PropTypes.func.isRequired,
        seats: PropTypes.number.isRequired,
    };

    _handleSeatChange(event) {
        this.props.updateSeats(parseInt(event.target.value, 10));
    }

    render() {
        return (
            <input
                value={this.props.seats}
                onChange={(e) => this._handleSeatChange(e)}
                type="number"
                step="1"
                className="form-control seat-input"
                min="1"
                max="999999"
            />
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Cart/SeatInput.jsx